import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo } from "react";
import { useSelector } from "react-redux";
import { AssetModalPanelContainer } from "~/components/AssetModal/Panel/Content/Container";
import { ReadonlyAssetTitleAndDescription } from "~/components/AssetModal/shared/components/InfoPanel/components/AssetTitleAndDescription/ReadonlyAssetTitleAndDescription";
import { InfoPanelCameraDetails } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelCameraDetails/InfoPanelCameraDetails";
import { InfoPanelCopyright } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelCopyright";
import { InfoPanelCreator } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelCreator";
import { InfoPanelDateCreated } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelDateCreated";
import { InfoPanelDateModified } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelDateModified";
import { InfoPanelFileDetails } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelFileDetails";
import { InfoPanelLoadingSkeleton } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelLoadingSkeleton";
import { InfoPanelLocation } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelLocation";
import { InfoPanelUploadedBy } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelUploadedBy";
import { InfoPanel } from "~/components/AssetModal/shared/components/InfoPanel/InfoPanel";
import { centralizedClipIdSelector, centralizedClipVersionNumberSelector } from "~/store/centralizedClip/selectors";
import { usePublicClipMetadata } from "~/swr-hooks/clips/usePublicClipMetadata";
import { canSeeAssetVersions } from "~/utils/permissions/assetPermissions";
import { PublicInfoPanelSummary } from "./PublicInfoPanelSummary";
export const PublicAssetModalInfoPanel = /*#__PURE__*/ memo((param)=>{
    let { permissions } = param;
    const canViewAllVersions = canSeeAssetVersions(permissions);
    const clipVersion = useSelector(centralizedClipVersionNumberSelector);
    const { shortId } = useShortIdContext();
    const clipId = useSelector(centralizedClipIdSelector);
    const { data: clipMetadata, isLoading } = usePublicClipMetadata({
        clipId,
        shortId
    });
    const isInitialLoading = isLoading && !clipMetadata;
    return /*#__PURE__*/ _jsx(AssetModalPanelContainer, {
        title: canViewAllVersions ? "Version ".concat(clipVersion, " info") : "Info",
        panel: /*#__PURE__*/ _jsx(InfoPanel, {
            title: /*#__PURE__*/ _jsx(ReadonlyAssetTitleAndDescription, {}),
            children: isInitialLoading ? /*#__PURE__*/ _jsx(InfoPanelLoadingSkeleton, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(PublicInfoPanelSummary, {}),
                    /*#__PURE__*/ _jsx(InfoPanelDateCreated, {}),
                    !!clipMetadata && /*#__PURE__*/ _jsx(InfoPanelLocation, {
                        clipMetadata: clipMetadata.data
                    }),
                    /*#__PURE__*/ _jsx(InfoPanelFileDetails, {
                        clipMetadata: clipMetadata === null || clipMetadata === void 0 ? void 0 : clipMetadata.data
                    }),
                    !!clipMetadata && /*#__PURE__*/ _jsx(InfoPanelCreator, {
                        clipMetadata: clipMetadata.data
                    }),
                    !!clipMetadata && /*#__PURE__*/ _jsx(InfoPanelCameraDetails, {
                        clipMetadata: clipMetadata.data
                    }),
                    /*#__PURE__*/ _jsx(InfoPanelDateModified, {}),
                    /*#__PURE__*/ _jsx(InfoPanelUploadedBy, {}),
                    !!clipMetadata && /*#__PURE__*/ _jsx(InfoPanelCopyright, {
                        clipMetadata: clipMetadata.data
                    })
                ]
            })
        })
    });
});
PublicAssetModalInfoPanel.displayName = "PublicAssetModalInfoPanel";
